export default class Homework {
  constructor({
    id = null,
    title = '',
    description = '',
    release_date = '',
    file_paths = [],
    semester_id = null,
    teacher_id = null,
    created_at = '',
    updated_at = '',
    files_metadata = [],
    deadline_dates = null,
    archived = false,
  }) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.release_date = release_date;
    this.file_paths = file_paths;
    this.semester_id = semester_id;
    this.teacher_id = teacher_id;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.files_metadata = files_metadata;
    this.deadline_dates = deadline_dates;
    this.archived = archived;
  }

  // Basic validation for homework data
  static validate(homeworkData) {
    if (!homeworkData.title) {
      throw new Error('Title is required');
    }
    if (!homeworkData.description) {
      throw new Error('Description is required');
    }
    if (!homeworkData.release_date) {
      throw new Error('Release date is required');
    }
    if (!homeworkData.semester_id) {
      throw new Error('Semester ID is required');
    }
    if (!homeworkData.teacher_id) {
      throw new Error('Teacher ID is required');
    }
  }

  // Format date to DD.MM.YYYY
  static formatDate(datetime) {
    const date = new Date(datetime);
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  static formatDateForInput(date) {
    return date ? date.split('T')[0] : '';
  }
}

export class HomeworkWithRelatedData extends Homework {
constructor({
  teacher = null,
  semester = null,
  subtasks = [],
  deadlines = [],
  ...homeworkData
}) {
  super(homeworkData);
  this.teacher = teacher;
  this.semester = semester;
  this.subtasks = subtasks;
  this.deadlines = deadlines;
}
}

export class HomeworkWithTeacherAndSemester extends Homework {
  constructor({
    teacher = null,
    semester = null,
    ...homeworkData
  }) {
    super(homeworkData);
    this.teacher = teacher;
    this.semester = semester;
  }
}

// F12: student homework list with backend-computed status
export class HomeworkStatus {
  constructor({
    homework_id = null,
    title = '',
    description = null,
    release_date = null,
    archived = false,
    deadline_dates = {},
    is_released = false,
    hw_status = 'closed',
    nearest_deadline = null,
    nearest_deadline_type = null,
    submitted_subtasks_count = 0,
    total_required_subtasks = 0,
    last_evaluation_passed = null,
    last_evaluation_in_queue = false,
  } = {}) {
    this.homework_id = homework_id;
    this.title = title;
    this.description = description;
    this.release_date = release_date;
    this.archived = archived;
    this.deadline_dates = deadline_dates;
    this.is_released = is_released;
    this.hw_status = hw_status;
    this.nearest_deadline = nearest_deadline;
    this.nearest_deadline_type = nearest_deadline_type;
    this.submitted_subtasks_count = submitted_subtasks_count;
    this.total_required_subtasks = total_required_subtasks;
    this.last_evaluation_passed = last_evaluation_passed;
    this.last_evaluation_in_queue = last_evaluation_in_queue;
  }

  // Expose .id so the template can use item.id for router-link
  get id() { return this.homework_id; }
}

// F12: teacher homework list stats
export class HomeworkTeacherStats {
  constructor({
    homework_id = null,
    students_submitted_count = 0,
    students_total_count = 0,
    students_evaluated_count = 0,
    students_passed_count = 0,
  } = {}) {
    this.homework_id = homework_id;
    this.students_submitted_count = students_submitted_count;
    this.students_total_count = students_total_count;
    this.students_evaluated_count = students_evaluated_count;
    this.students_passed_count = students_passed_count;
  }
}

// F9: one homework on the timeline (AUTO deadlines + per-deadline state for a student)
export class HomeworkTimelineItem {
  constructor({
    homework_id = null,
    title = '',
    release_date = null,
    is_released = false,
    is_closed = false,
    auto_deadlines = [],
  } = {}) {
    this.homework_id = homework_id;
    this.title = title;
    this.release_date = release_date;
    this.is_released = is_released;
    this.is_closed = is_closed;
    // [{ deadline_id, date, evaluation_type, phase, state, counted_evaluation_id }]
    this.auto_deadlines = auto_deadlines;
  }
}
